module.exports = __webpack_public_path__ + "img/website.98aed4f8.gif";